import { Link } from 'gatsby';
import styled from '@emotion/styled';

const NavListFlyoutLink = styled(Link)`
  color: ${({ theme }) => theme.text.medium};
  display: block;
  font-size: 14px;
  padding: 8px 0;
  transition: color 0.25s ease;

  &:hover {
    color: ${({ theme }) => theme.secondary.base};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.gray.medium};
  }
`;

export default NavListFlyoutLink;
